<template>
  <div>
    <div class="inner">
      <div class="header">
        <img @click="$router.push({
            name:'Profilo'})" src="../../assets/user.svg" />
        <img
          class="points"
          src="../../assets/points.png"
          @click="$router.push({
            name:'Punti'})"
        />
      </div>

      <img class="points" src="../../assets/todaypoints.png" />
    </div>
    <img class="bg" src="../../assets/headerbghome.png" />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "HeaderHome"
};
</script>


<style lang="less" scoped>
.bg {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>